module.exports = __webpack_public_path__ + "/images/cover-fr-recibiendo-dinero.d02241a.png";